import React from "react";

class BG1 extends React.Component {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 139.031 109.562">
        <path
          id="connectionSlideBg1"
          d="M406,376c13.481-17.617,106.985-18.21,124-1,15.05,15.222-.48,59.379-29,79-33.091,22.766-68.268,22.211-87,8C396.733,448.9,389.8,397.169,406,376Z"
          transform="translate(-396.844 -362.438)"
          fill="currentColor"
        />
        <path
          id="connectionSlideIcon1"
          data-name="Forma 1"
          className="cls-1"
          d="M486.761,407.106a4.223,4.223,0,0,0-5.966,0l-4.231,4.234V400.2a4.191,4.191,0,0,0-1.236-2.983l-3.978-3.977A4.189,4.189,0,0,0,468.367,392H444.219A4.224,4.224,0,0,0,440,396.219v39.562A4.224,4.224,0,0,0,444.219,440h28.126a4.224,4.224,0,0,0,4.219-4.219v-12.5l10.2-10.206A4.215,4.215,0,0,0,486.761,407.106Zm-18.635-12.294a1.535,1.535,0,0,1,1.236.412l3.977,3.978a1.534,1.534,0,0,1,.412,1.235h-5.625v-5.625Zm5.625,40.969a1.408,1.408,0,0,1-1.406,1.407H444.219a1.408,1.408,0,0,1-1.406-1.407V396.219a1.408,1.408,0,0,1,1.406-1.407h21.094v7.032a1.407,1.407,0,0,0,1.407,1.406h7.031v10.9l-4.149,4.153-1.988,1.988a1.406,1.406,0,0,0-.34.549l-1.989,5.967a1.406,1.406,0,0,0,1.779,1.778l5.967-1.988a1.406,1.406,0,0,0,.549-0.34l0.171-.171v9.69h0ZM470.6,421.29l1.989,1.989-0.76.759-2.983,1,0.994-2.983Zm3.977,0-1.988-1.989,6.76-6.766,1.988,1.989Zm10.2-10.206-1.45,1.45-1.988-1.988,1.45-1.452A1.406,1.406,0,1,1,484.772,411.084Zm-18.052-5.021H447.031a1.406,1.406,0,0,0,0,2.812H466.72A1.406,1.406,0,0,0,466.72,406.063Zm-5.626,5.624H447.031a1.407,1.407,0,0,0,0,2.813h14.063A1.407,1.407,0,1,0,461.094,411.687Zm0,5.626H447.031a1.406,1.406,0,0,0,0,2.812h14.063A1.406,1.406,0,1,0,461.094,417.313Zm0,5.624H447.031a1.407,1.407,0,0,0,0,2.813h14.063A1.407,1.407,0,1,0,461.094,422.937Zm5.626,8.625h-8.438a1.407,1.407,0,0,0,0,2.813h8.438A1.407,1.407,0,0,0,466.72,431.562Z"
          transform="translate(-390 -370)"
          fill="currentColor"
        />
      </svg>
    );
  }
}

export default BG1;
